module.exports = __webpack_public_path__ + "img/signn_top1.0a504134.png";